const TYPES = {
    GET_NEWS: 'GET_NEWS',
    GET_NEWS_COMPLETE: 'GET_NEWS_COMPLETE',
    GET_NEWS_FAILED: 'GET_NEWS_FAILED',
    GET_ARTICLE: 'GET_ARTICLE',
    GET_ARTICLE_COMPLETE: 'GET_ARTICLE_COMPLETE',
    GET_ARTICLE_FAILED: 'GET_ARTICLE_FAILED'
};

export default {
    TYPES,

    getNews: (payload?) => ({
        type: TYPES.GET_NEWS,
        payload
    }),

    getNewsSuccess: (payload?) => ({
        type: TYPES.GET_NEWS_COMPLETE,
        payload
    }),

    getNewsFailed: (error?) => ({
        type: TYPES.GET_NEWS_FAILED,
        payload: {error}
    }),

    getArticle: (payload?) => ({
        type: TYPES.GET_ARTICLE,
        payload
    }),

    getArticleSuccess: (payload?) => ({
        type: TYPES.GET_ARTICLE_COMPLETE,
        payload
    }),

    getArticleFailed: (error?) => ({
        type: TYPES.GET_ARTICLE_FAILED,
        payload: {error}
    })
};
